import {
    ISearch,
    ISearchProfile,
    ISearchProvider,
    HorizAlignment,
    SearchProviderFieldType,
    ISearchProviderField, ISearchRequestSubset
} from "../PA.UIM.Core/PA.UIM.Core.IF.Search"
import {PASearch, ISearchRequest} from "../PA.Core/PASearch";
import {SearchUtils} from "../PA.UIM.Core/SearchUtils";
import {PAEnvironment} from "../PA.Core/PAEnvironment";
import * as _ from "lodash";
import {TPMEventSpendSearch} from "../PA.UIM.TPM/TPMEventSpendSearch";


const PaymentSearch: ISearch = {
    searchName: "Find Payment ",
    renderOptions: {ui5ResourceId: "PaymentSearch"},
    searchProfileIdDefault: "default",
    searchProfiles: []
};


const vUI_Payment_Search_Fields: { [id: string]: ISearchProviderField } = {
    WB_PMT_ID:         {type: SearchProviderFieldType.number, renderOptions: {columnName:  'Payment WB Id', columnResourceName: 'colId',              alignment: HorizAlignment.Center}, domainOptions: {}},
    PAYMENT_ID:        {type: SearchProviderFieldType.string, renderOptions: {columnName:  'Payment Id',    columnResourceName: 'colPaymentId',       alignment: HorizAlignment.Left}, domainOptions: {maxLength: 50}},
    PAYMENT_NAME:      {type: SearchProviderFieldType.string, renderOptions: {columnName:  'Name',          columnResourceName: 'colName',            alignment: HorizAlignment.Left},   domainOptions: {maxLength: 256}},
    PAYMENT_TYPE_NAME: {type: SearchProviderFieldType.string, renderOptions: {columnName:  'Type',          columnResourceName: 'colTypeName',        alignment: HorizAlignment.Left},   domainOptions: {search: PaymentSearch, profileId: "default", bUseSearchProvidersDistinctValues: true, maxLength: 256}},
    PAYMENT_DT:        {type: SearchProviderFieldType.sapdate, renderOptions: {columnName: 'Pmt Date',      columnResourceName: 'colPaymentDt',       alignment: HorizAlignment.Left},  domainOptions: {maxLength: 10}},
    PAYMENT_AMT:       {type: SearchProviderFieldType.number, renderOptions: {columnName:  'Payment Amt',   columnResourceName: 'colPmtAmt',          alignment: HorizAlignment.Right},  domainOptions: {}},
    CURRENCY:          {type: SearchProviderFieldType.string, renderOptions: {columnName:  'Currency',      columnResourceName: 'colPaymentCurrency', alignment: HorizAlignment.Left},  domainOptions: {maxLength: 10}},
    CUSTOMER:          {type: SearchProviderFieldType.string, renderOptions: {columnName:  'Customer',      columnResourceName: 'colCustomerName',  alignment: HorizAlignment.Left},   domainOptions: {search: PaymentSearch, profileId: "default", bUseSearchProvidersDistinctValues: true, maxLength: 256}},
    CUSTOMER_ID:       {type: SearchProviderFieldType.string, renderOptions: {columnName:  'Customer Id',   columnResourceName: 'colCustomerName',  alignment: HorizAlignment.Left},   domainOptions: {maxLength: 50}},
    FUNDING_CUSTOMER:  {type: SearchProviderFieldType.string, renderOptions: {columnName:  'Funding Customer',      columnResourceName: 'colFundingCustomerName',  alignment: HorizAlignment.Left},   domainOptions: {maxLength: 256}},
    PLANNING_CUSTOMER: {type: SearchProviderFieldType.string, renderOptions: {columnName:  'Planning Customer',      columnResourceName: 'colPlanningCustomerName',  alignment: HorizAlignment.Left},   domainOptions: {maxLength: 256}},
    PERIOD_NAME:       {type: SearchProviderFieldType.string, renderOptions: {columnName:  'Period',        columnResourceName: 'colPeriodName',    alignment: HorizAlignment.Left},   domainOptions: {search: PaymentSearch, profileId: "default", bUseSearchProvidersDistinctValues: true, maxLength: 256}},
    STATUS_NAME:       {type: SearchProviderFieldType.string, renderOptions: {columnName:  'Status',        columnResourceName: 'colStatusName',    alignment: HorizAlignment.Left},   domainOptions: {search: PaymentSearch, profileId: "default", bUseSearchProvidersDistinctValues: true, maxLength: 256}},
    APPROVED_DTTS:     {type: SearchProviderFieldType.number, renderOptions: {columnName:  'Approved Dt',   columnResourceName: 'colStatusName',    alignment: HorizAlignment.Left},   domainOptions: {}},
    CHECK_NUMBER:      {type: SearchProviderFieldType.string, renderOptions: {columnName:  'Check #',       columnResourceName: 'colCheckNum',      alignment: HorizAlignment.Left},   domainOptions: {maxLength: 50}},
    PAYMENT_ID_REF:    {type: SearchProviderFieldType.string, renderOptions: {columnName:  'Payment Ref',   columnResourceName: 'colPaymentRefId',  alignment: HorizAlignment.Center}, domainOptions: {maxLength: 50}},
    PAYMENT_ID_COR:    {type: SearchProviderFieldType.string, renderOptions: {columnName:  'Payment Cor',   columnResourceName: 'colPaymentCorId',  alignment: HorizAlignment.Center}, domainOptions: {maxLength: 50}},
    CREATED_DTTS: {
        type: SearchProviderFieldType.sapdate,
        renderOptions: {
            columnName: 'Created Date',
            columnResourceName: 'colCreateDt',
            alignment: HorizAlignment.Center,
            dateFormat: "MM-dd-yy"
        },
        domainOptions: {}
    },
    MODIFIED_DTTS: {
        type: SearchProviderFieldType.sapdate,
        renderOptions: {
            columnName: 'Modified Date',
            columnResourceName: 'colModifiedDt',
            alignment: HorizAlignment.Center,
            dateFormat: "MM-dd-yy"
        },
        domainOptions: {}
    }
};

const PaymentSearchProviderBasic: ISearchProvider = {

    keyFields: {
        id:    'WB_PMT_ID',
        id_ui: 'PAYMENT_ID',
        name:  'PAYMENT_NAME'
    },


    searchProviderFields: vUI_Payment_Search_Fields,

    search(searchOptions: ISearchRequestSubset): Promise<any[]> {
        return new Promise<any[]>((resolve, error) => {

            let findRequest = SearchUtils.makeSearchRequest(searchOptions,
                'vUI_Payment_Search',
                this.searchProviderFields,
                [])

            PASearch.findByRequest(findRequest)
                .then((res: any[]) => {
                    resolve(res)
                })
                .catch((err) => {
                    error(err)
                })
        })
    },

    distinctValues(fieldName: string): Promise<string[] | number[]> {
        return new Promise<string[] | number[]>((resolve, error) => {
            let findRequest = SearchUtils.makeSearchRequest({},
                'vUI_Payment_Search',
                this.searchProviderFields,
                [fieldName])

                PASearch.findByRequest(findRequest)
                .then((res: any[]) => {
                    resolve(_.map(res, (aRow) => { return aRow[fieldName] }))
                })
                .catch((err)=> {
                    error(err)
                })
        })
    }


};


const PaymentSearchProfileByName: ISearchProfile = {
    profileId: "default",
    profileName: "Search by Id, Name",
    renderOptions: {ui5ResourceId: "PaymentSearchProfileByName"},

    profileFilter: [
        {profileFilterName: 'Id',       searchProviderFieldId: 'PAYMENT_ID',         renderOptions: {}},
        {profileFilterName: 'Name',     searchProviderFieldId: 'PAYMENT_NAME',      renderOptions: {}},
        {profileFilterName: 'Customer', searchProviderFieldId: 'CUSTOMER',          renderOptions: {}, bMultiSelect: true},
        {profileFilterName: 'Status',   searchProviderFieldId: 'STATUS_NAME',       renderOptions: {}, bMultiSelect: true},
        {profileFilterName: 'Type',     searchProviderFieldId: 'PAYMENT_TYPE_NAME', renderOptions: {}, bMultiSelect: true},
    ],
    profileDisplayFields: [
        'CUSTOMER', 'PAYMENT_DT', 'PAYMENT_TYPE_NAME', 'PAYMENT_ID', 'PAYMENT_NAME', 'STATUS_NAME', 'PAYMENT_AMT','CURRENCY','CHECK_NUMBER','PAYMENT_ID_REF','PAYMENT_ID_COR',
        'CREATED_DTTS', 'MODIFIED_DTTS'
    ],

    profileSearchProvider: PaymentSearchProviderBasic,

    profileSortIdDefault: "",    //string;
    profileSorts: [] //ISearchSort[];
};

PaymentSearch.searchProfiles.push(PaymentSearchProfileByName)

PAEnvironment.registerBusinessObjectSearch("PaymentBO", "Payment", PaymentSearch, "Payment Search")

export {PaymentSearch}